import { render, staticRenderFns } from "./PricingTabButtons.vue?vue&type=template&id=477f45ae&scoped=true"
import script from "./PricingTabButtons.vue?vue&type=script&lang=js"
export * from "./PricingTabButtons.vue?vue&type=script&lang=js"
import style0 from "./PricingTabButtons.vue?vue&type=style&index=0&id=477f45ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477f45ae",
  null
  
)

export default component.exports